// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatSetPostPolicyBody = {
  chatId: string;
  postPolicy: "everyone" | "officersOnly";
};

export type typeChatSetPostPolicyOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string; postPolicy: "everyone" | "officersOnly" };
};

export type typeChatSetPostPolicyOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatSetPostPolicyOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatSetPostPolicyOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatSetPostPolicyBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    postPolicy: { type: "string", enum: ["everyone", "officersOnly"] },
  },
  required: ["chatId", "postPolicy"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatSetPostPolicy(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatSetPostPolicyBody);
  }

  return async function postChatSetPostPolicy(
    payload: typeChatSetPostPolicyBody,
  ): Promise<typeChatSetPostPolicyOutput200 | typeChatSetPostPolicyOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatSetPostPolicy" failed before calling the network. #46e8d45b95e9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#46e8d45b95e9" },
        },
        data: null,
      } as typeChatSetPostPolicyOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/set-post-policy`,
      httpMethod: "POST",
      options,
    })) as typeChatSetPostPolicyOutput200 | typeChatSetPostPolicyOutput400;
  };
}
